import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ConsultaPage } from './consulta';
import { ChartsModule } from 'ng2-charts/ng2-charts';

@NgModule({
  declarations: [
    ConsultaPage,
  ],
  imports: [
    IonicPageModule.forChild(ConsultaPage),
    ChartsModule
  ],
  exports:[
    ConsultaPage
  ]
})
export class ConsultaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/consulta/consulta.module.ts